<template>
  <Dialog
    :dialogTitle="'找回签约密码'"
    :visible="show"
    :width="'450px'"
    @closeDialog="closeDialog"
    v-if="userInfo"
  >
    <div slot="dialog" class="findFormContaniner">
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" size="mini">
          <el-form-item :label="userInfo.mobile?'手机号码':'邮箱'"><span style="
              overflow: hidden;
              display: inline-block;
              width: 190px;
              text-overflow: ellipsis;
              white-space: nowrap;">{{userInfo.mobile || userInfo.mail}}</span></el-form-item>
          <el-form-item label="验证码" prop="authCode" class="elInputCustomer">
            <el-input v-model="ruleForm.authCode"></el-input>
            <span class="getAuthCode cursorPointer" @click="getAuthCode" v-if="!countdowning">获取验证码</span>
            <span class="getAuthCode" v-if="countdowning">{{countdownValue}}</span>
          </el-form-item>
          <el-form-item label="新密码" prop="pwd">
            <el-input type="password" v-model="ruleForm.pwd"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPwd">
            <el-input type="password" v-model="ruleForm.confirmPwd"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="authHandlerBox">
        <div class="button buttonActive cursorPointer" @click="closeDialog">取消</div>
        <div class="button cursorPointer buttonActive" @click="submitForm('ruleForm')">确定</div>
      </div>
    </div>
  </Dialog>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import Reg from "@lib/reg.js";
import BaseApi from "@lib/baseApi.js";
import md5Util from "@lib/encryption.js";
export default {
  data() {
    var validatePassConFirm = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      show: true,
      countdownValue: 60,
      countdowning: false,
      ruleForm: {
        mobile: "",
        authCode: "",
        pwd: "",
        confirmPwd: "",
        mail: ""
      },
      userInfo: null,
      rules: {
        authCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: Reg.AUTHCODE,
            message: "验证码为6位数字",
            trigger: "blur"
          }
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: Reg.PWD,
            message: "密码为6-18位密码",
            trigger: "blur"
          }
        ],
        confirmPwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePassConFirm, trigger: "blur" }
        ]
      }
    };
  },
  components: {
    Dialog
  },
  created() {
    BaseApi.createRpcToken("/user/v2/getUserInfo").then(
      data => {
        this.userInfo = data.datas.person;
        console.log(" this.userInfo", this.userInfo)
      },
      err => {}
    );
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.show = false;
      this.$emit("closeDialog");
    },
    getAuthCode() {
      BaseApi.createRpcToken(
        "/common/getSignatoryPWDRetrieveCode",
        {
          account: this.userInfo.mobile || this.userInfo.mail
        },
        "post"
      )
        .then(
          data => {
            this.doCountdown();
          },
          () => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    doCountdown: function() {
      if (this.countdownValue == 1) {
        this.countdowning = false;
        this.countdownValue = 60;
        return;
      }
      setTimeout(this.doCountdown, 1000);
      this.countdowning = true;
      this.countdownValue--;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let query = {
            code: this.ruleForm.authCode,
            password: md5Util.md5(this.ruleForm.pwd)
          };
          if (this.userInfo.mobile) {
            query.mobile = this.userInfo.mobile;
          } else if (this.userInfo.mail) {
            query.mail = this.userInfo.mail;
          }
          BaseApi.createRpcToken("/user/retrieveSignatoryPWD", query, "post")
            .then(
              data => {
                if (data.datas.code == 200) {
                  this.$message.success("成功找回密码");
                  this.$emit("closeDialog");
                } else {
                  this.$message.success("找回密码失败");
                }
              },
              () => {}
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.findFormContaniner {
  height: 290px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .form {
    width: 280px;
    margin-top: 30px;
    margin-bottom: 10px;
    .elInputCustomer {
      .el-form-item__content {
        .el-input {
          width: 90px;
        }
        .getAuthCode {
          margin-left: 15px;
          font-size: 14px;
          color: #70c8e5;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
